import { from } from 'rxjs';
import { blobToBase64 } from '../../../tools';
import { MessageContentTypes } from '../models/message.model';

export const changeMsgBodyStyle = msg => msg?.replace('<p>', "<p class='text-justify'>");

export function convertImageToBase64(data) {
	return from(blobToBase64(data));
}
export function typeExtractor(text: string): any {
	if (text.includes('عرضه اولیه')) {
		return MessageContentTypes.ArzeAvalie;
	}
	if (text.includes('بورس انرژی')) {
		return MessageContentTypes.Energy;
	}
	if (text.includes('عدم تایید')) {
		return MessageContentTypes.NotConfirm;
	}
	if (text.includes('گشایش')) {
		return MessageContentTypes.Goshayesh;
	}
	if (text.includes('توقف') || text.includes('تعلیق')) {
		return MessageContentTypes.TavaghofNamad;
	}
	if (text.includes('پذیره')) {
		return MessageContentTypes.PazireNevisi;
	}
	if (text.includes('دامنه مجاز')) {
		return MessageContentTypes.DamaneMojaz;
	}
	if (text.includes('عمده')) {
		return MessageContentTypes.Omde;
	}
	if (text.includes('سررسید')) {
		return MessageContentTypes.SarResid;
	}
	if (text.includes('بازگشایی')) {
		return MessageContentTypes.BazGoshayi;
	}
	if (text.includes('اطلاعیه')) {
		return MessageContentTypes.Ettelaeeye;
	}
	if (text.includes('بازارگردانی')) {
		return MessageContentTypes.Bazargardani;
	}
	if (text.includes('حراج')) {
		return MessageContentTypes.Haraj;
	}
	if (text.includes('رفع گره')) {
		return MessageContentTypes.RafeeGere;
	}
	if (text.includes('استفاده نشده')) {
		return MessageContentTypes.EstefadeNashode;
	}
	if (text.includes('مسکن')) {
		return MessageContentTypes.Maskan;
	} else return MessageContentTypes.Other;
}
export function readyToCallService(date?: Date) {
	return new Date().getTime() - (date?.getTime() ?? 0) > 2000;
}
